import React from 'react';
import LazyLoad from 'react-lazyload';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Trash2, Minus, Plus } from 'lucide-react';
import { getThumbnailApiUrl } from '../../../../../apis/devices';
import { Form, Col, Row, Card, Accordion, Button, Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { luminaireImageProjectApiUrlCompleted } from '../../../../../apis/projects';
import { retrieveLuminaireImageProject, deleteDriver, updateDriverCount } from '../../../../../actions';
import Checkbox from 'components/shared/StandaloneCheckbox';
import { LED_MODULE } from '../../../../../utils/constantFeatures';
import ProjectInfoLedModule from './ProjectInfoLedModule';
import ProjectPlaceholder from '../../ProjectPlaceholder';
import { Trans, withTranslation } from 'react-i18next';

class ProjectInfo extends React.Component {

    constructor(props) {
        super(props);

        const { t } = this.props;
        this.state = {
            toggleButton: t('More_info'),//'More info',
            isCheckedOM: false,

            deletingLoader: false,
            driverToDelete: null,

            imageAlreadyInError: false,
        };

        this.isCheckedOpMode = this.isCheckedOpMode.bind(this);
        this.handleChangeAccordionToggle = this.handleChangeAccordionToggle.bind(this);
        this.handleChangeOpMode = this.handleChangeOpMode.bind(this);
        this.onDeleteDriver = this.onDeleteDriver.bind(this);
        this.deleteDriver = this.deleteDriver.bind(this);
        this.updateDriverCount = this.updateDriverCount.bind(this);

    }

    getSelectedOperatingMode() {

        if (this.props.opmodes === null) {
            return undefined;
        }

        for (let i = 0; i < this.props.opmodes.length; i++) {

            if (this.props.opmodesSelected && this.props.opmodesSelected.id === this.props.opmodes[i].id) {
                return this.props.opmodes[i].id;
            }
        }

        return this.props.opmodes.length > 0 ? this.props.opmodes[0].id : null;
    }

    renderOperatingModeList() {

        if (this.props.opmodes === null) {
            return [];
        }

        const operatingModes = [];

        for (let i = 0; i < this.props.opmodes.length; i++) {
            operatingModes.push(
                <option value={this.props.opmodes[i].id} key={this.props.opmodes[i].id}>
                    {this.props.opmodes[i].displayName}
                </option>
            );

        }
        return operatingModes;
    }

    openFileDialog() {
        document.getElementById("projectImageInput").click();
    }

    addDefaultSrc(picRef, e) {
        if (!this.state.imageAlreadyInError && picRef !== undefined && picRef !== null) {
            this.props.retrieveLuminaireImageProject(this.props.project.id)
                .then(() => {
                    var reader = new FileReader();
                    reader.readAsDataURL(this.props.luminaireImage);
                    reader.onloadend = function () {
                        var base64data = reader.result.replace("application/octet-stream", "image/png");
                        document.getElementById("projectImage").src = base64data;
                    }
                });

            e.target.src = picRef;
            this.setState({ imageAlreadyInError: true });
        }
    }

    handleChangeAccordionToggle() {
        var toggleButton = this.state.toggleButton;
        const { t } = this.props;

        this.setState({ toggleButton: toggleButton === t("More_info") ? t("Less_info") : t("More_info") });
    }

    isCheckedOpMode() {
        if (this.props.checkedFeatures) {
            return this.props.checkedFeatures.indexOf("om") !== -1;
        }

        return false;
    }

    handleChangeOpMode(e) {
        const value = e.target.checked;
        this.setState({
            isCheckedOM: value
        });

        this.props.onCheckFeature("om", value);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.checkedFeatures !== prevProps.checkedFeatures) {
            this.setState({ isCheckedOM: this.props.checkedFeatures.indexOf("om") !== -1 });
        }
    }

    containsLedModuledata() {
        if (this.props.driverFeatures === undefined || this.props.driverFeatures === null) {
            return false;
        }
        for (var i=0; i<this.props.driverFeatures.length; i++) {
            if (this.props.driverFeatures[i].name === LED_MODULE.shortName) {
                return true;
            }
        }
        return false;
    }

    onDeleteDriver() {
        this.setState({ driverToDelete: this.props.driver });
    }

    deleteDriver() {
        //starting loader
        this.setState({ deletingLoader: true });

        const { history } = this.props;

        this.props.deleteDriver(this.props.project.id, this.props.driver.driverId)
            .then(() => {
            //stop loader
                this.setState({ driverToDelete: null, deletingLoader: false });

                //if there are drivers in the project open the first one otherwise open home page in order to select a new driver
                if (history) {
                    if (Object.keys(this.props.drivers)[0]) {
                        history.push('/projects/' + this.props.project.id + '/driver/' + Object.keys(this.props.drivers)[0]);
                    } else {
                        history.push('/');
                    }
                }
            });
    }

    updateDriverCount(actionType) {
        let count = this.props.count;

        if (actionType === 'decrement') {
            count -= 1;
        }
        else {
            count += 1;
        }

        this.props.updateDriverCount(this.props.project.id, this.props.driver.driverId, count);
    }

    render() {
        const { t } = this.props;

        if (!this.props.driver || this.state.deletingLoader) {
            return (<ProjectPlaceholder />);
        }

        const picRef = this.props.driver && this.props.driver.picRef
            ? getThumbnailApiUrl(this.props.driver.picRef)
            : null;

        const datasheet = this.props.driver ? this.props.driver.docUrl : null;

        const classNameSwitch = this.state.isCheckedOM ? 'switch-opMode-selected' : 'switch-opMode';

        return (
            <div>
                <Modal show={this.state.driverToDelete !== null} onHide={() => this.setState({ driverToDelete: null })} animation={false}>
                    <Modal.Header closeButton>
                        <Modal.Title style={{ color: "#E95B0D" }}>{t("Warning")}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p> {t("Are_you_sure_remove_driver")} <i>{this.state.driverToDelete ? (this.state.driverToDelete.basicCode) : ''}</i> {t("from_the_project")} </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" style={{ marginRight: "0" }} onClick={this.deleteDriver}>{t("Yes")}</Button>
                        <Button variant="secondary" onClick={() => this.setState({ driverToDelete: null })}>{t("No")}</Button>
                    </Modal.Footer>
                </Modal>

                <Accordion defaultActiveKey="1" className="card-project-info">
                    <Card>
                        {/* <Card.Header style={{ backgroundColor: "#424242" }}> */}
                        <Card.Header style={{ paddingLeft: 0 }}>
                            <Row className="row-create-project">

                                <Form.Group as={Col} md="3" controlId="opmodesSelected" style={{ paddingLeft: 0, margin: '0', display: "flex" }}>
                                    {
                                        this.props.driver
                                            ?
                                            <Checkbox
                                                onChange={this.handleChangeOpMode}
                                                checked={this.state.isCheckedOM}
                                                className={classNameSwitch}
                                            />
                                            :
                                            null
                                    }
                                    <Form.Label style={{ fontWeight: "700", paddingRight: "12px" }}><Trans i18nKey="Operating_Mode" /></Form.Label>
                                    {
                                        this.props.driver
                                            ?
                                            <Form.Control as="select"
                                                onChange={this.props.handleChangeOperatingMode}
                                                placeholder="Operating Mode"
                                                value={this.getSelectedOperatingMode()}
                                                multiple={false} >
                                                {this.renderOperatingModeList()}
                                            </Form.Control>
                                            :
                                            <div onClick={this.props.openAddDriver}>
                                                <Form.Control
                                                    disabled
                                                    value={t('Please_select_Device_Before')}
                                                    placeholder="0" />
                                            </div>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md="3" controlId="deviceTypeName" style={{ margin: '0', display: "flex" }}>
                                    {/* <Form.Label style={{ fontWeight: "700" }}>Device Type</Form.Label> */}
                                    {
                                        this.props.driver
                                            ?
                                            <Form.Control
                                                style={{ paddingLeft: '0' }}
                                                disabled
                                                required
                                                name="driver"
                                                type="text"
                                                value={this.props.driver.deviceTypeName}
                                                onChange={this.props.handleChange}
                                                placeholder="Device Type" />
                                            :
                                            <div onClick={this.props.openAddDriver}>
                                                <Form.Control
                                                    disabled
                                                    value={t('Please_select_Device')}
                                                    placeholder="0" />
                                            </div>
                                    }

                                    <Form.Control.Feedback>{t('Looks_good')}</Form.Control.Feedback>
                                </Form.Group>

                                {
                                    this.containsLedModuledata() ?
                                        <ProjectInfoLedModule
                                            properties= {this.props.driverProperties}
                                            handleChange={this.props.handleChangeDriverProperties}/>
                                        : <Form.Group as={Col} md="3" controlId="name" style={{ margin: '0', display: "flex" }}></Form.Group>
                                }

                                {/* To add className based on this.state.toggleButton */}
                                <Accordion.Toggle as={Button} variant="secondary" md="2" eventKey="0" onClick={this.handleChangeAccordionToggle}
                                    style={{ borderRadius: '1.4rem', padding: '0 0.75rem', height: '1.8rem', fontSize: '0.8rem' }}>
                                    {this.state.toggleButton}
                                </Accordion.Toggle>

                                <div md="1" style={{ position: "absolute", top: "16px", right: "10px" }}>
                                    <OverlayTrigger
                                        rootClose
                                        placement="left"
                                        overlay={(props) => <Tooltip {...props}>{t("Delete_driver")}</Tooltip>}>
                                        <Button className="delete-driver-button" onClick={this.onDeleteDriver}>
                                            <Trash2 className="delete-driver-icon"  />
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            </Row>
                        </Card.Header>

                        <Accordion.Collapse eventKey="0">
                            <Card.Body style={{padding: '0'}}>
                                <Form
                                    className="center"
                                    noValidate
                                    /* validated={validated} */ >
                                    <fieldset disabled={this.props.disabled} style={{ width: '100%' }} className='moreInfoAccordion'>
                                        <Row className="row-create-project">
                                            <Col sm="12" md="12" lg="12" xl="5" style={{ padding: '0' }}>
                                                <Row className="row-form-project-info" style={{ margin: '0', minHeight:'60px' }}>
                                                    <Form.Group as={Col} md="4" controlId="orderCode">
                                                        <Form.Label>{t("Order_code")}</Form.Label>
                                                        <Form.Control
                                                            name="projectOrderCode"
                                                            type="text"
                                                            value={this.props.projectOrderCode}
                                                            onChange={this.props.handleChangeProjectInfo}
                                                            placeholder={t("Order_code")}
                                                        //isdanger={!!this.props.errors.orderCode}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="gtin">
                                                        <Form.Label>GTIN/EAN/NAED</Form.Label>
                                                        {
                                                            this.props.driver
                                                                ?
                                                                <div>{this.props.driver.gtin || this.props.driver.naed}</div>
                                                                :
                                                                <div onClick={this.props.openAddDriver}>
                                                                    <Form.Control
                                                                        disabled
                                                                        value={t('Please_select_Device_Before')}
                                                                        placeholder="0" />
                                                                </div>
                                                        }
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="formPlaintextEmail">
                                                        <Form.Label>{t("Basic_Code")}</Form.Label>
                                                        {
                                                            this.props.driver
                                                                ?
                                                                <div>{this.props.driver.basicCode}</div>
                                                                :
                                                                <div onClick={this.props.openAddDriver}>
                                                                    <Form.Control
                                                                        disabled
                                                                        value={t('Please_select_Device_Before')}
                                                                        placeholder="0" />
                                                                </div>
                                                        }
                                                    </Form.Group>

                                                </Row>
                                                <Row className="row-form-project-info" style={{ margin: '0', minHeight:'100px' }}>
                                                    <Form.Group as={Col} md="4" controlId="description">
                                                        <Form.Label>{t("Description")}</Form.Label>
                                                        {/* <Form.Control
                                                            name="projectDescription"
                                                            type="text"
                                                            value={this.props.projectDescription}
                                                            onChange={this.props.handleChangeProjectInfo}
                                                            placeholder="Description"
                                                        /> */}
                                                        <textarea
                                                            style={{"resize": "none", "width": "100%"}}
                                                            rows={3}
                                                            name="projectDescription"
                                                            maxLength={1000}
                                                            value={this.props.projectDescription}
                                                            onChange={this.props.handleChangeProjectInfo}
                                                        />
                                                        <Form.Control.Feedback>{t('Looks_good')}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="customer">
                                                        <Form.Label>{t("Customer_Project")}</Form.Label>
                                                        <Form.Control
                                                            name="projectCustomer"
                                                            type="text"
                                                            value={this.props.projectCustomer}
                                                            onChange={this.props.handleChangeProjectInfo}
                                                            placeholder={t("Customer_Project")}
                                                        //isdanger={!!this.props.errors.customer}
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="numberOfDevices">
                                                        <Form.Label>{t("numberOfDevices")}</Form.Label>
                                                        <Form.Control
                                                            disabled
                                                            type="number"
                                                            min="0"
                                                            value={this.props.drivers ? Object.keys(this.props.drivers).length : 0}
                                                            placeholder="0"
                                                        />
                                                        <Form.Control.Feedback>{t('Looks_good')}</Form.Control.Feedback>
                                                    </Form.Group>

                                                </Row>
                                            </Col>
                                            <Col sm="12" md="12" lg="12" xl="4" style={{ paddingBottom:'20px' }}>
                                                <Row>
                                                    <Form.Group as={Col} md="12" controlId="formPlaintextEmail">
                                                        {
                                                            this.props.driver && this.props.driver.description
                                                                ?
                                                                <div>
                                                                    <Form.Label>{t("Description")}</Form.Label>
                                                                    <div style={{ marginRight: '20px', overflowY: 'auto', }}>
                                                                        {this.props.driver.description}
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </Form.Group>
                                                </Row>
                                                <Row>
                                                    <Form.Group as={Col} md="4" controlId="serialNumber">
                                                        <Form.Label>{t("Serial_Number")}</Form.Label>
                                                        <Form.Control
                                                            disabled
                                                            type="text"
                                                            value={this.props.driver.serialNumber}
                                                            placeholder="N/A"
                                                        />
                                                    </Form.Group>
                                                    <Form.Group as={Col} md="4" controlId="fwVersion">
                                                        <Form.Label>{t("FW_Version")}</Form.Label>
                                                        <Form.Control
                                                            disabled
                                                            type="text"
                                                            value={this.props.driver.fwVersion}
                                                            placeholder="N/A"
                                                        />
                                                    </Form.Group>

                                                    <Form.Group as={Col} md="4" controlId="fwVersion" className="driver-count-buttons-wrapper" >
                                                        {/* <Col md="5" className="driver-count-buttons-wrapper"> */}
                                                        <Form.Label>{t("Driver_Count")}</Form.Label>
                                                        <br/>
                                                        <Button
                                                            variant="outline-secondary"
                                                            onClick={() => this.updateDriverCount("decrement")}
                                                            disabled={this.props.count === 1 ? true : false}>
                                                            <Minus style={{color: "rgba(0, 0, 0, 0.54)"}} size={20} />
                                                        </Button>
                                                        <span> {this.props.count} </span>
                                                        <Button
                                                            variant="outline-secondary"
                                                            onClick={() => this.updateDriverCount("increment")}>
                                                            <Plus style={{color: "rgba(0, 0, 0, 0.54)"}} size={20} />
                                                        </Button>
                                                        {/* </Col> */}
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Col sm="12" md="6" lg="6" xl="2">
                                                <Row>
                                                    <Form.Group as={Col} md="2" controlId="datasheet">
                                                        <Form.Label style={{width: "max-content"}}><div style={{ marginBottom: '0.5rem', float: 'right', cursor: 'pointer' }} onClick={this.openFileDialog} className="datasheet">{t("Change_Image")}</div></Form.Label>
                                                        <LazyLoad className="app thumb-placeholder center"
                                                            once={true}
                                                            overflow={true}
                                                            offset={[0, 300]}
                                                            placeholder={<i className="ui centered icon camera" />}>

                                                            <img
                                                                style={{ maxHeight: '4.75rem', maxWidth: '12.5rem' }}
                                                                src={luminaireImageProjectApiUrlCompleted(this.props.project.id)}
                                                                onError={(e) => this.addDefaultSrc(picRef, e)}
                                                                id="projectImage"
                                                                alt="Project luminaire" />
                                                        </LazyLoad>
                                                        <input type='file' accept='image/*' id="projectImageInput" onChange={this.props.handleChangeLuminaireImage} hidden />
                                                    </Form.Group>
                                                </Row>
                                            </Col>
                                            <Col sm="12" md="6" lg="6" xl="1" style={{ display: 'flex' }}>
                                                <Form.Group as={Col} controlId="datasheet" style={{ display: 'flex', margin: '0' }}>
                                                    <Form.Label><a href={datasheet} target="_blank" rel="noopener noreferrer" className="datasheet">{t("Datasheet")}</a></Form.Label>

                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </fieldset>
                                </Form>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        luminaireImage: state.project.luminaireImage,
        count: state.driver.count
    };
};

const mapDispatchToProps = {
    retrieveLuminaireImageProject,
    deleteDriver,
    updateDriverCount
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation()
)(ProjectInfo);
